.sn-steps-line-type-1 {
  &__header {
    text-align: center;
    margin-bottom: px-to-rem(24px);

    @include above(480px) {
      margin-bottom: px-to-rem(30px);
    }

    @include above(768px) {
      margin-bottom: px-to-rem(48px);
    }

    @include desktop {
      margin-bottom: px-to-rem(54px);
    }

    @include above(1440px) {
      margin-bottom: px-to-rem(80px);
    }

    me-heading {
      display: block;
      margin-left: auto;
      margin-right: auto;

      @include above(480px) {
        max-width: px-to-rem(366px);
      }

      @include above(768px) {
        max-width: px-to-rem(494px);
      }

      @include desktop {
        max-width: px-to-rem(576px);
      }

      @include above(1440px) {
        max-width: px-to-rem(768px);
      }
    }
  }

  &__wrapper {
    max-width: px-to-rem(342px);
    margin: 0 auto;

    @include above(768px) {
      max-width: px-to-rem(535px);
    }

    @include desktop {
      max-width: 100%;
    }
  }

  &__list {
    position: relative;
    list-style: none;
    margin: 0;
    padding: 0;

    @include desktop {
      display: flex;
      flex-direction: row;
    }

    // Collapsed (default on mobile): hide items 4+ and fade out the bottom edge
    .sn-steps-line-type-1__item:nth-child(n+4) {
      display: none;

      @include desktop {
        display: block;
      }
    }

    // Item 3 is effectively the last visible on mobile when collapsed — hide its connecting line
    .sn-steps-line-type-1__item:nth-child(3) .sn-steps-line-type-1__badge::before {
      display: none;

      @include desktop {
        display: block;
      }
    }

    &::after {
      content: '';
      position: absolute;
      width: 100%;
      height: px-to-rem(87px);
      z-index: 1;
      bottom: 0;
      pointer-events: none;
      background: linear-gradient(180deg, rgb(255 255 255 / 0%) 0%, var(--background-color-primary) 76%);

      @include desktop {
        display: none;
      }
    }

    // Expanded state: reveal all items and remove fade overlay
    &--expanded {
      &::after {
        display: none;
      }

      .sn-steps-line-type-1__item:nth-child(n+4) {
        display: flex;

        @include desktop {
          display: block;
        }
      }

      // Restore connecting line on item 3 now that item 4 is visible
      .sn-steps-line-type-1__item:nth-child(3) .sn-steps-line-type-1__badge::before {
        display: block;
      }
    }
  }

  &__item {
    display: flex;
    flex-direction: row;
    width: 100%;
    margin-bottom: px-to-rem(30px);
    position: relative;
    font-size: px-to-rem(14px);
    line-height: px-to-rem(20px);

    @include above(480px) {
      margin-bottom: px-to-rem(32px);
    }

    @include desktop {
      display: block;
      margin-bottom: 0;
    }

    &:last-child {
      .sn-steps-line-type-1__badge::before {
        display: none;

        @include desktop {
          display: block;
        }
      }
    }

    &:nth-child(1) .sn-steps-line-type-1__badge {
      background: #e6f3ff;
      color: #367ff6;
    }

    &:nth-child(2) .sn-steps-line-type-1__badge {
      background: #fff3e6;
      color: #f87350;
    }

    &:nth-child(3) .sn-steps-line-type-1__badge {
      background: #e6faf7;
      color: #00c6b1;
    }

    &:nth-child(4) .sn-steps-line-type-1__badge {
      background: #ecf2ff;
      color: #1d5fbf;
    }

    &:nth-child(5) .sn-steps-line-type-1__badge {
      background: #fff3e6;
      color: #f87350;
    }

    &:nth-child(6) .sn-steps-line-type-1__badge {
      background: #e6faf7;
      color: #00c6b1;
    }
  }

  // Circular numbered badge. No position:relative — ::before is positioned relative to __item.
  &__badge {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    min-width: px-to-rem(32px);
    width: px-to-rem(32px);
    height: px-to-rem(32px);
    margin-right: px-to-rem(20px);
    font-family: Graphik, Arial, sans-serif;
    font-weight: 700;
    font-size: px-to-rem(12px);
    line-height: px-to-rem(16px);
    border-radius: var(--radius-size-full);

    @include above(768px) {
      min-width: px-to-rem(40px);
      width: px-to-rem(40px);
      height: px-to-rem(40px);
      margin-right: px-to-rem(40px);
      font-size: px-to-rem(14px);
      line-height: px-to-rem(20px);
    }

    @include desktop {
      margin-right: 0;
      margin-bottom: px-to-rem(24px);
    }

    @include above(1440px) {
      margin-bottom: px-to-rem(32px);
    }

    // Connecting line between steps.
    // Positioned relative to __item (nearest positioned ancestor), not the badge itself.
    &::before {
      content: '';
      position: absolute;
      width: px-to-rem(1px);
      height: 72%;
      top: px-to-rem(52px);
      left: px-to-rem(19px);
      background: #c9d0de;

      @include desktop {
        width: 80%;
        height: px-to-rem(1px);
        top: px-to-rem(20px);
        left: px-to-rem(72px);
      }
    }
  }

  &__text {
    font-size: px-to-rem(14px);
    line-height: px-to-rem(20px);
    color: var(--text-color-primary);
    flex: 1;

    @include above(768px) {
      margin-right: px-to-rem(12px);
    }

    @include desktop {
      margin-right: px-to-rem(16px);
    }
  }

  &__title {
    font-weight: 700;
  }

  &__read-more {
    display: block;
    text-align: center;
    margin-top: px-to-rem(10px);
    margin-left: 0;
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    color: var(--color-brand-primary);
    font-size: px-to-rem(14px);
    line-height: px-to-rem(20px);
    text-decoration: underline;

    @include above(768px) {
      font-size: px-to-rem(16px);
      margin-top: px-to-rem(32px);
    }

    @include below-desktop {
      margin: 0 auto;
    }

    @include desktop {
      display: none;
    }
  }
}
